module.exports = __webpack_public_path__ + "assets/urgent-care.f5acfe14.png";